module.exports = __webpack_public_path__ + "static/media/Poster_Mockup.3f4bbdc8.jpg";